import styled from 'styled-components';

export const MainContainerCorriere = styled.div`
border-top: 1px solid ${props => props.theme.colors.gray2};
background-color: #fff;
display: flex;
flex-direction: row;
width: 992px;
margin: auto;
${props => props.theme.mediaQueries.tablet_big_down_world_cup}{
    padding: 0px;
    width: 100%;
    overflow: auto;
    border-top: none;
    border-bottom: none;
};
.resetLink, .resetLink:link, .resetLink:visited {
    text-decoration: none !important;
    display: inline;
}
`;

export const DayStripWidgetWrapper = styled.div`
padding-top: 7px;
width: 954px;
${props => props.theme.mediaQueries.tablet_big_down_world_cup}{
    padding-bottom: 15px;
    box-sizing: content-box;
    width: 100%;
    background-color: ${props => props.theme.colors.lightGray2};
    height: 227px;
};

white-space: nowrap;
position: relative;
.flex {
  display: flex;
}
.justifyContentStart {
  justify-content: flex-start;
}
.justifyContentCenter {
  justify-content: center;
}
.justifyContentEnd {
  justify-content: flex-end;
}
.justifyContentBetween {
  justify-content: space-between;
}
.alignItemsCenter {
  align-items: center;
}
.LiveMainColorBackground {
  background-color: ${props => props.theme.colors.lightBlue2};
}
.preMainColorBackground {
  background-color: #DEDEDE;
}
`;

export const ArrowContainer = styled.div`
display: flex;
justify-content: center;
flex-direction: column;
align-items: center;
padding: 0px;
`;

export const MatchWrapper = styled.div`
max-width: 919px;
min-height: 110px;
margin-top: 14px;
width: auto;
overflow: hidden;
display: flex;
white-space: nowrap;
justify-content: flex-start;
 > a:last-child > div {
  margin-right: 2px;
 }
 > a:first-child {
  margin-left: 2px;
 }
 ${props => props.theme.mediaQueries.tablet_big_down_world_cup}{
    margin-bottom: 22px;
    overflow: auto;
    > a:last-child > div {
      margin-right: 10px;
    }
    > a:first-child {
      margin-left: 10px;
    }
  };
`;



// WEBPACK FOOTER //
// ./src/containers/CalendarCorriereWidget/styles.js